import { createApiHooks, useGenericGet, useGenericPost } from '../../../../../hooks/use-api.hook';
import { apiClient } from '../../../../../services/api-client.service';
import type { Tenant, TenantGetResponse, TenantUpdate } from '../types/tenant.types';
import type { UseListParams } from '../../../../../types/pagination.types';
import { useMemo } from 'react';

const useTenantBasePath = () => {
  return useMemo(() => {
    return '/v1/admin/tenants';
  }, []);
};

export const useTenantHooks = () => {
  const tenantBasePath = useTenantBasePath();

  return createApiHooks<Tenant, TenantGetResponse, unknown, TenantUpdate>({
    basePath: tenantBasePath,
    queryKey: ['Tenants'],
    apiClient,
  });
};

// Create a custom hook that returns all the tenant hooks
export const useTenantApi = () => {
  const tenantHooks = useTenantHooks();

  return {
    useGet: tenantHooks.useGet,
    useCreate: tenantHooks.useCreate,
    useUpdate: tenantHooks.useUpdate,
    useDelete: tenantHooks.useDelete,
    useList: (params: UseListParams) => tenantHooks.useList(params),
  };
};

// Export individual hooks for backward compatibility
export const useTenantGet = (id: string | number, queryOptions?: any) => {
  const { useGet } = useTenantApi();
  return useGet(id, queryOptions);
};

export const useTenantUpdate = (mutationOptions?: any) => {
  const { useUpdate } = useTenantApi();
  return useUpdate(mutationOptions);
};
